import * as z from 'zod'

export const createRuleSchema = z.object({
  effectiveStart: z.string().min(1, 'Effective start is required'),
  effectiveEnd: z
    .string()
    .nullish()
    .transform((val) => val || null),
  coverageScope: z.enum(['full', 'unincorporated_only'], {
    required_error: 'Coverage scope is required',
  }),
  reference: z.string().optional(),
  jurisdictionIds: z.array(z.number()).optional(),
})

export type CreateRuleSchema = z.infer<typeof createRuleSchema>
